import React from "react"
import "./Avatar.css"


const Avatar = ({ src, alt, fallback, size = "medium", className = "" }) => {
  const sizeClass = `avatar-${size}`

  return (
    <div className={`avatar ${sizeClass} ${className}`}>
      {src ? (
        <img src={src || "/placeholder.svg"} alt={alt} className="avatar-image" />
      ) : (
        <div className="avatar-fallback">{fallback}</div>
      )}
    </div>
  )
}

export default Avatar
